import { RECIEVE_USERS } from './actions/Users';

class UserList {
  constructor(users) {
    this.users = users;
  }

  get = id => id ? this.users.find(user => user.id === id) : this.users;

  forOrg  = orgId => this.users.filter(i => i.orgId === orgId);
}

const initialState = new UserList([]);

const UserReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case RECIEVE_USERS: {
      return new UserList(action.users);
    }
    default:
      return state;
  }
};

export default UserReducer;



// WEBPACK FOOTER //
// ./src/redux/UsersReducer.js